import {HttpAxiosRequest} from "../../../../../http/httpAxiosBase";
import {
  FormOperacionControlOperativoDetalle,
  OperacionControlOperativoDetalle,
  schemaFormOperacionControlOperativoDetalle,
  schemaOperacionControlOperativoDetalle,
} from "../types/types";
import {BaseResponse, BaseResponseWithData} from "../../../../../types";
import {
  OperacionControlOperativoInsertDTO,
  OperacionControlOperativoViewDTO, schemaOperacionControlOperativoInsert,
  schemaOperacionControlOperativoView
} from "../types/dto";
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";


export const getEndpoint = (url = '') => `operaciones/control-operativo${url}`;

export const HttpControlOperativo = {
  get: (idOperacion: number): Promise<OperacionControlOperativoViewDTO> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionControlOperativoView.safeParse(response);

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues);

          return Promise.reject(new Error('Error de validación.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },

  post: (operacion: OperacionControlOperativoInsertDTO): Promise<BaseResponseWithData<number>> => {
    const parsed = schemaOperacionControlOperativoInsert.safeParse(operacion);

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues);

      return Promise.reject(new Error('Error de validación.'));
    }

    return HttpAxiosRequest.post(getEndpoint(), parsed.data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  getDetalle: (idOperacion: number): Promise<OperacionControlOperativoDetalle> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/detalles`))
      .then(response => {
        const parsed = schemaOperacionControlOperativoDetalle.safeParse(response);

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues);

          return Promise.reject(new Error('Error de validación.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  putDetalle: (idOperacion: number, idOperacionDetalle: number, detalle: FormOperacionControlOperativoDetalle): Promise<BaseResponse> => {
    const parsed = schemaFormOperacionControlOperativoDetalle.safeParse(detalle);

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues);

      return Promise.reject(new Error('Error de validación.'));
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/detalles/${idOperacionDetalle}`), parsed.data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  descargarInforme: (idOperacion: number): Promise<any> =>
      HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.ControlOperativo),
};